<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title page-title">
      <p>{{ formInfo.title }}</p>
      <span @click="backPre">返回</span>
    </div>
    <div class="panel-content center_content">
      <div id="list">
        <table>
          <tbody>
            <tr class="l_header">
              <th class="itemStatus">姓名</th>
              <th class="itemStatus">实验结果</th>
              <th class="itemStatus">实验成绩</th>
              <th class="itemStatus">实验开始时间</th>
              <th class="itemStatus">实验结束时间</th>
              <th class="itemStatus">实验用时</th>
              <th
                class="action"
                width="130"
              >操作
              </th>
            </tr>
            <tr
              class="item"
              v-for="(item, index) in tableData"
              :key="index"
            >
              <td>{{item.experimentStudent.userprofile.name}}</td>
              <td>{{ item.status ? '完成' : '未完成' }}</td>
              <td>{{ item.score }}</td>
              <td>{{ item.startTime.replace('T', ' ') }}</td>
              <td>{{ item.endTime.replace('T', ' ') }}</td>
              <td>{{ item.timeUsed }}</td>
              <td>
                <a
                  class="edit"
                  href="javascript:;"
                  @click="viewDetail(item)"
                >查看详情</a>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="noitems"
          v-if="tableData.length == 0"
        >没有数据</div>
      </div>
      <!-- 分页 -->
      <pagination
        :cur='pageInfo.page'
        :all='pageInfo.all'
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
    </div>
    <div
      class="form_overlay"
      :style="classShowDetailWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel form_panel_item">
        <div class="form_title">详情
          <span @click="classShowDetailWindow={}">X</span>
        </div>
        <div class="form_content">
          <div class="experiment_text">
            <p>实验名称：{{ formInfo.title }}</p>
            <p><span>实验开始时间：{{ experimentGrade.startTime }}</span>
              <span>实验结束时间：{{ experimentGrade.endTime }}</span>
              <span>实验用时：{{ experimentGrade.timeUsed }}</span>
            </p>
            <p><span>实验满分：100</span>
              <span>实验得分：{{ experimentGrade.score }}</span>
              <span>实验结果：{{ experimentGrade.status ? '完成' : '未完成' }}</span>
            </p>
          </div>
          <div class="f_list">
            <table v-if="tableStepData.length">
              <tbody>
                <tr class="l_header">
                  <th class="itemStatus">步骤名称</th>
                  <th class="itemStatus">步骤开始时间</th>
                  <th class="itemStatus">步骤结束时间</th>
                  <th class="itemStatus">步骤用时(秒)</th>
                  <th class="itemStatus">步骤合理用时(秒)</th>
                  <th class="itemStatus">步骤满分</th>
                  <th class="itemStatus">步骤得分</th>
                  <th class="itemStatus">步骤操作次数</th>
                  <th class="itemStatus">步骤评价</th>
                  <th class="itemStatus">赋分模型</th>
                  <th class="itemStatus">备注</th>
                </tr>
                <tr
                  class=""
                  v-for="item in tableStepData"
                  :key="item.id"
                >
                  <td class="itemStatus">{{ item.title }}</td>
                  <td class="itemStatus">{{ item.startTime.replace('T', ' ') }}</td>
                  <td class="itemStatus">{{ item.endTime.replace('T', ' ') }}</td>
                  <td class="itemStatus">{{ item.timeUsed }}</td>
                  <td class="itemStatus">{{ item.expectTime }}</td>
                  <td class="itemStatus">{{ item.maxScore }}</td>
                  <td class="itemStatus">{{ item.score }}</td>
                  <td class="itemStatus">{{ item.repeatCount }}</td>
                  <td class="itemStatus">{{ item.evaluation }}</td>
                  <td class="itemStatus">{{ item.scoringModel }}</td>
                  <td class="itemStatus">{{ item.remarks }}</td>
                </tr>
              </tbody>
            </table>
            <div
              class="noitems"
              v-else
            >没有数据
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pager'

export default {
  name: 'viewScore',
  components: {
    Pagination
  },
  data() {
    return {
      tableData: [],
      tableDataCount: 0,
      queryInfo: {
        page: 1,
        size: 10,
        experiment_id: '',
        expJoinParam: '',
        expJoinType: 11
      },
      classShowDetailWindow: {},
      tableStepData: [],
      experimentGrade: {},
      formInfo: {}
    }
  },
  methods: {

    async search() {
      const onlineStudentStudyData = await this.$http.get('/online_student_study/', {
        params: {
          onlineStudent_id: this.$route.query.studentId,
          onlineStudy_id: this.$route.query.studyId
        }
      })
      if (onlineStudentStudyData.results.length === 0) {
        this.tableData = []
        this.tableDataCount = 0
      } else {
        this.queryInfo.expJoinParam = onlineStudentStudyData.results[0].id
        await this.$http.get('/experimentgrade/', {
          params: this.queryInfo
        }).then((data) => {
          this.tableData = data.results
          this.tableDataCount = data.count
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    // 获取实验信息
    async getExperimentInfo() {
      const url = '/experiment/' + this.$route.query.experiment_id + '/'
      await this.$http.get(url).then((data) => {
        this.formInfo = data
      }).catch((error) => {
        console.log(error)
      })
    },
    async viewDetail(item) {
      item.startTime = item.startTime.replace('T', ' ')
      item.endTime = item.endTime.replace('T', ' ')
      this.experimentGrade = item
      this.classShowDetailWindow = {
        visibility: 'visible'
      }
      const params = {
        page: 1,
        size: 10000,
        experimentGrade_id: item.id
      }

      await this.$http.get('/experimentstep/', {
        params: params
      }).then((data) => {
        this.tableStepData = data.results
      }).catch(() => {
        this.$layer.msg('获取成绩信息失败！')
      })
    },
    backPre() {
      this.$router.go(-1)
    },

    pageCallback(data) {
      this.queryInfo.page = data
      this.search()
    }

  },
  mounted() {
    this.queryInfo.experiment_id = this.$route.query.experiment_id
    this.search()
    this.getExperimentInfo()
  },
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    }

  }
}
</script>

<style scoped src="@/assets/css/project-detail.css"></style>
<style lang="less" scoped>
table {
  table-layout: fixed;
}
.form_title {
  position: relative;
  margin-bottom: 20px;
}

.form_title span {
  position: absolute;
  right: 0;
  top: 0;
  background: #ff8383 repeat scroll 0 0;
  color: #ff8383;
  cursor: pointer;
  height: 30px;
  line-height: 28px;
  text-align: center;
  width: 30px;
  font-size: 24px;
  border-radius: 3px;
  overflow: hidden;
}

.form_title span::before {
  content: "×";
  display: block;
  width: 30px;
  height: 30px;
  font-family: 宋体;
  color: rgb(255, 255, 255);
}

.experiment_text {
  margin-bottom: 20px;
}

.experiment_text p {
  line-height: 3;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.experiment_text p span {
  flex: 1;
}
.form_panel_item {
  max-width: 1300px;
  margin: 0;
  transform: translate(-50%, -50%);
}
.page-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    background: #73D6CA;
    color: #fff;
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 14px;
    line-height: normal;
    cursor: pointer;
  }
}
</style>
